<div class="page-content">
  <div fxLayout="column" fxLayoutAlign="center center" style="height: 80vh">
    <img src="assets/images/rspl_logo.png" alt="Resupply" />
    <h1>404</h1>
    <h2>Ooops! Page not found</h2>
    @if (message) {
      <p [innerHtml]="message" class="message"></p>
    }
    @if (url) {
      <p class="url">{{ url }}</p>
    }
  </div>
</div>
